var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'base-cta-txt',
    _vm.ctaType,
    { disabled: _vm.disabled },
    { active: _vm.active } ],attrs:{"title":_vm.label},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.label,30))+" "),(_vm.ctaType == 'CTA-txt-2')?_c('BaseArrow',{ref:"baseArrow",staticClass:"arrow",attrs:{"size":"small"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }